import { ChainId } from 'web3/chains'

export const WSTRAX_ADDRESS = {
  [ChainId.STRATIS]: '0xeA705D2DbD8DE7Dc70Db7B531D0F620d9CeE9d18',
  [ChainId.AURORIA]: '0x6f39A32C3E7A54164e1C6E201979aec276B0Da8E',
}
